import React from 'react';

import { FieldProps } from 'formik';

import { OptionalProps } from '@rbi-ctg/frontend';
import { DateInput, IDateInputProps } from 'components/ucl';
import { t } from 'state/intl/translations';

export const FormikDateInput = ({
  field,
  form,
  label,
  autoComplete,
  onChange,
  ...props
}: FieldProps &
  OptionalProps<
    IDateInputProps,
    | 'label'
    | 'labelYear'
    | 'labelYearFormat'
    | 'labelMonth'
    | 'labelMonthFormat'
    | 'labelDay'
    | 'labelDayFormat'
  >) => {
  const errors = form.touched[field.name] ? (form.errors?.[field.name] as string) : undefined;

  return (
    <DateInput
      autoComplete={autoComplete}
      testID={field.name}
      {...field}
      label={label ?? ''}
      labelYear={t('year')}
      labelYearFormat={t('yearPlaceholder')}
      labelMonth={t('month')}
      labelMonthFormat={t('monthPlaceholder')}
      labelDay={t('day')}
      labelDayFormat={t('dayPlaceholder')}
      {...props}
      errorMessage={errors}
      onBlur={form.handleBlur}
      onChange={onChange}
      month={form.values[field.name].month}
      day={form.values[field.name].day}
      year={form.values[field.name].year}
    />
  );
};
